import React from 'react';

import tabNextArrow from '../../../../../assets/tabNextArrow.svg';

import styles from './TargetAudienceHeader.module.css';

import { TARGET_AUDIENCE_STEPS } from '../../../SurveyBuilder/helpers/constants';

const stepTitle = {
  [TARGET_AUDIENCE_STEPS.SOCIO_DEMOGRAPHICS]: 'Socio demographics',
  [TARGET_AUDIENCE_STEPS.PROFILING_QUESTIONS]: 'Profiling questions',
  [TARGET_AUDIENCE_STEPS.NOT_ELIGIBLE_RESPONDENTS]: 'Not eligible respondents',
  [TARGET_AUDIENCE_STEPS.SAMPLE_SIZE]: 'Sample size'
};

export default ({
  TARGET_AUDIENCE_TAB,
  TARGET_AUDIENCE_WIZARD_STEPS,
  targetAudienceStep,
  setTargetAudienceStep,
  surveyId,
  history
}) => {
  const currentStepIndex = TARGET_AUDIENCE_WIZARD_STEPS.indexOf(
    targetAudienceStep
  );

  const isBackAvailable = currentStepIndex >= 1;
  const isNextAvailable =
    currentStepIndex <= TARGET_AUDIENCE_WIZARD_STEPS.length - 2;

  const onClickBack = () => {
    if (isBackAvailable) {
      const previousStep = TARGET_AUDIENCE_WIZARD_STEPS[currentStepIndex - 1];
      setTargetAudienceStep(previousStep);
      history.push(
        `/survey/${surveyId}/edit/${
          TARGET_AUDIENCE_TAB.name
        }/${previousStep.toLowerCase()}`
      );
    }
  };

  const onClickNext = () => {
    if (isNextAvailable) {
      const nextStep = TARGET_AUDIENCE_WIZARD_STEPS[currentStepIndex + 1];
      setTargetAudienceStep(nextStep);
      history.push(
        `/survey/${surveyId}/edit/${
          TARGET_AUDIENCE_TAB.name
        }/${nextStep.toLowerCase()}`
      );
    }
  };

  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <div className={styles.back} onClick={onClickBack} role="presentation">
          {isBackAvailable ? (
            <img
              src={tabNextArrow}
              alt="Next"
              className={`${styles.arrow} ${styles.left}`}
            />
          ) : null}
        </div>
        <div className={styles.title}>{stepTitle[targetAudienceStep]}</div>
        <div className={styles.next} onClick={onClickNext} role="presentation">
          {isNextAvailable ? (
            <img src={tabNextArrow} alt="Next" className={styles.arrow} />
          ) : null}
        </div>
      </div>
    </div>
  );
};
